import { render, staticRenderFns } from "./SubcontractUfTaxSelector.vue?vue&type=template&id=536035a4&"
import script from "./SubcontractUfTaxSelector.vue?vue&type=script&lang=js&"
export * from "./SubcontractUfTaxSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports